import { Component, Input } from '@angular/core';
import { CurrencyPipe } from '@angular/common';

@Component({
  selector: 'app-tool-rental-details',
  templateUrl: './tool-rental-details.component.html',
  styleUrls: ['../../tool-page/tool-page.component.scss'],
})
export class ToolRentalDetailsComponent {
  @Input() disabled?: boolean;
  @Input() dataModel: any;
  @Input() formattedValue: any;

  constructor(private currencyPipe: CurrencyPipe) {}

  ngOnChanges() {
    this.formatToCurrency('rentalPriceDaily');
    this.formatToCurrency('rentalPriceWeekly');
    this.formatToCurrency('rentalPriceMonthly');
  }

  /* to remove currency data for string */
  removeCurrencyData(data) {
    return parseFloat(data.toString().replace(/\$|,/g, ''));
  }

  formatToCurrency(property: string, event: any = null) {
    if (event) {
      this.dataModel[property] = this.removeCurrencyData(this.dataModel[property]);
    }
    if (this.dataModel[property]) {
      this.formattedValue[property] = this.currencyPipe.transform(
        parseFloat(this.dataModel[property].toString()),
        '$ ',
      );
    } else {
      this.formattedValue[property] = '';
    }
  }
}
